import { render, staticRenderFns } from "./QuickSettingConfig.vue?vue&type=template&id=47ea0dba&scoped=true"
import script from "./QuickSettingConfig.vue?vue&type=script&lang=ts"
export * from "./QuickSettingConfig.vue?vue&type=script&lang=ts"
import style0 from "./QuickSettingConfig.vue?vue&type=style&index=0&id=47ea0dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea0dba",
  null
  
)

export default component.exports